import { createGtm } from '@gtm-support/vue-gtm'

import asyncTracker from '@/trackers/async-tracker.js'
import { isDisabledThirdPartyScript, isLocalhost } from '@/utils/browser.js'
import { ternary } from '@/utils/common.js'
import webview from '@/utils/webview.js'

window.dataLayer = window.dataLayer || []

const sendToApp = (name, payload) => {
  const { analyticWeb, firebase } = webview.getStatus()
  // Android Interface
  if (analyticWeb) {
    analyticWeb.logEvent(name, JSON.stringify(payload))
    return
  }
  // iOS Interface
  const message = {
    command: 'logEvent',
    name,
    parameters: payload
  }
  firebase.postMessage(message)
}

const pushToDataLayer = data => {
  const { isApp, hasAppApi } = webview.getStatus()
  if (isApp && !hasAppApi) {
    /* eslint-disable-next-line no-console */
    console.log('No webview tracking bridge interface injected by app.')
  }

  if (isApp && hasAppApi) {
    sendToApp(data.id, data)
    return
  }
  window.dataLayer.push({ params: null, ecommerce: null })
  window.dataLayer.push(data)
}

const trackLearnMore = (origin_screen) => {
  asyncTracker.call('commonTracker', 'trackButtonClick', {
    origin_screen,
    component: 'learn_more'
  })
}

const getGTMID = () => {
  //for no mock, use 'GTM-5MG5GBV'
  return ternary(isLocalhost(), 'GTM-XXX', window._GTM_ID)
}

const initGTM = (app, router) => {
  const gtmId = getGTMID()
  if (!isDisabledThirdPartyScript()) {
    app.use(
      createGtm({
        id: gtmId,
        debug: false,
        vueRouter: router
      })
    )
  }
}

export {
  getGTMID,
  initGTM,
  pushToDataLayer,
  trackLearnMore
}
